
import React, { useEffect, useState } from 'react';
import { RIGHTARROW_ICON, TOOLTIPICON } from "../../../utills/image-constant";
import { addAssestmentByUserWithAdminToken, clearResponeAssesmentAdmin, getAllAnswerByEmpIdwithAdminToken, getCriteriaByModelIdwithadmintoken, getCriteriaByModelIdwithfilterwithAdminToken, getOptionsByCriteriaIdwithAdminToken } from '../../../services/api-services';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import { ROUTES } from '../../routes/url-constant';
import TableHeading from '../../components/common/TableHeading';
import AdminTesteftbar from '../comman/adminTesteftbar';
import PreviewAllAdminAns from './previewAllAdminAns';
import OnSiteAssessmentTopBar from '../../components/common/OnSiteAssessmentTopBar';
import { cleanInvalidChars, decodeHtmlEntities } from '../../../utills/formutilities';
const AddOnSiteScore = () => {
    const location = useLocation();
    let CampaignData = location.state?.Data;


    const parsedEmployeeData = location?.state?.Data
    const [questionList, setQuestionList] = useState([]);
    const [importanceIndex, setImportanceIndex] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [targetIndex, setTargetIndex] = useState(null);
    const [InitialIndex, setinitialIndex] = useState(null);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isNextDisabled, setIsNextDisabled] = useState(true);
    const [validationMessage, setValidationMessage] = useState("");
    const [optionListLoader, setOptionListloader] = useState(false);
    const [ansListLoader, setAnsListloader] = useState(false);
    const [submitLoader, setSubmittloader] = useState(false);
    const [savedAnsList, setSavedAnsList] = useState([]);
    const [quesListLoader, setQuesListloader] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [finalAssesmentModal, setFinalAssesmentModal] = useState(false)
    const [submitBtnDisable, setSubmitBtnDisable] = useState(false);
    const [backBtnDisable, setBackBtnDisable] = useState(false);
    const [comment, setComment] = useState();
    const [questionID, setQuestionID] = useState();
    const [validateMessgae, setValidateMessgae] = useState(true);
    const [addPayload, setAddpayload] = useState({
        id: "",
        employeeId: CampaignData?.assessorCampaignResponse?.companyAssessorId,
        modelId: CampaignData?.assessorCampaignResponse?.modelId,
        campaignId: CampaignData?.assessorCampaignResponse?.campaignId,
        isAssessment: 1,
        criteriaQuestionList: [],
    });
    const positionMap = ["13%", "31%", "50%", "68%", "85%"];
    const progress = savedAnsList?.length / (questionList?.length) * 100;

    const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);
    //  Disable Next when partial selection
    useEffect(() => {
        const anySelected =
            importanceIndex !== null || currentIndex !== null || targetIndex !== null;
        if (anySelected && (importanceIndex === null || currentIndex === null || targetIndex === null)) {
            setIsNextDisabled(true);
            setValidationMessage("⚠️ All three sliders (Importance, Current, future) must be selected.");
        } else {
            setIsNextDisabled(false);
            setValidationMessage("");
        }
    }, [importanceIndex, currentIndex, targetIndex]);

    // Fetch all criteria
    const getListOfQuestion = async () => {
        setQuesListloader(true)
        try {
            const response = await getCriteriaByModelIdwithfilterwithAdminToken(
                CampaignData?.assessorCampaignResponse?.modelId,//modalid
                CampaignData?.assessorCampaignResponse?.companyAssessorId,//enmp id
                CampaignData?.assessorCampaignResponse?.campaignId
            );

            if (response?.data?.responseCode === 200) {
                const modelResponse = response?.data?.responseBody;
                setQuesListloader(false)
                // Flatten structure with both actual Mongo IDs and logical IDs
                const allCriteria =
                    modelResponse?.dimensionResponseList?.flatMap((dimension) =>
                        (dimension?.subDimensionResponseList || []).flatMap((subDim) =>
                            (subDim?.criteriaResponseList || [])
                                .filter((criteria) => criteria?.criteriaShortLabel)
                                .map((criteria) => ({
                                    // --- Criteria Data ---
                                    criteriaId: criteria.criteriaId, // logical id (like 1.1.1.1)
                                    id: criteria?.id, // actual Mongo _id
                                    criteriaShortLabel: criteria.criteriaShortLabel,
                                    criteriaDescription: criteria.criteriaDescription,

                                    // --- Dimension Info ---
                                    dimensionId: dimension?.dimensionId, // logical id (e.g. 1.1)
                                    dimensionMongoId: dimension?.id,     // actual Mongo _id
                                    dimensionName: dimension?.dimensionName,

                                    // --- SubDimension Info ---
                                    subDimensionId: subDim?.subDimensionId, // logical id (e.g. 1.1.1)
                                    subDimensionMongoId: subDim?.id,        // actual Mongo _id
                                    subDimensionName: subDim?.subDimensionName,

                                    // --- Options ---
                                    optionResponseList: (criteria.optionResponseList || []).map((opt) => ({
                                        optionId: opt.id,
                                        value: opt.value,
                                        levelNumber: opt.levelNumber,
                                        description: opt.description,
                                    })),
                                }))
                        )
                    ) || [];

                setQuestionList(allCriteria);
            } else {
                setQuesListloader(false)
                setQuestionList([]);
            }
        } catch (err) {
            console.error("Error fetching model data:", err);
            setQuesListloader(false)
        }
    };
    useEffect(() => {
        getListOfQuestion();
    }, []);

    const getAllAnswer = async () => {
        setAnsListloader(true)
        try {
            const response = await getAllAnswerByEmpIdwithAdminToken(CampaignData?.assessorCampaignResponse?.companyAssessorId, CampaignData?.assessorCampaignResponse?.campaignId);
            if (response?.data?.responseCode === 200) {
                setSavedAnsList(response?.data?.responseBody?.criteriaQuestionList)
                setAddpayload(response?.data?.responseBody);
                setAnsListloader(false)
            }
            if (response?.data?.responseCode === 404) {
                setAddpayload({
                    id: "",
                    employeeId: CampaignData?.assessorCampaignResponse?.companyAssessorId,
                    campaignId: CampaignData?.assessorCampaignResponse?.campaignId,
                    modelId: CampaignData?.assessorCampaignResponse?.modelId,
                    isAssessment: 1,
                    criteriaQuestionList: []

                });
                setAnsListloader(false)

            }
        } catch (err) {
            console.error(err);
            setAnsListloader(false)
            toastEmitter("error", API_RESPONSE?.MESSAGE_503);
        }
    };

    useEffect(() => {
        getAllAnswer();
    }, []);

    //  Change current question
    useEffect(() => {
        setinitialIndex(questionList[currentQuestionIndex]);
    }, [questionList, currentQuestionIndex]);

    useEffect(() => {
        if (InitialIndex?.id && addPayload?.criteriaQuestionList?.length > 0) {
            const existing = addPayload.criteriaQuestionList.find(
                (q) => q.criteriaId === InitialIndex.id
            );
            setComment(existing?.comment || "");
        } else {
            setComment("");
        }
    }, [InitialIndex?.id, addPayload]);


    const handleRadioChange = (setter, level, bubbleText) => {
        setter(level.index);
        const selectedOption = {
            id: "",
            optionId: level?.optionId,
            optionValue: level?.value,
            optionType: bubbleText,
        };

        setAddpayload((prev) => {
            let updatedList = [...(prev?.criteriaQuestionList || [])];
            const existingIndex = updatedList.findIndex(
                (q) => q.criteriaId === InitialIndex?.id
            );

            if (existingIndex !== -1) {
                const oldQuestion = updatedList[existingIndex];
                const filteredOptions = oldQuestion.optionAnswerList.filter(
                    (opt) => opt.optionType !== bubbleText
                );
                updatedList[existingIndex] = {
                    ...oldQuestion,
                    comment: comment,
                    optionAnswerList: [...filteredOptions, selectedOption],
                };
            } else {
                updatedList.push({
                    id: "",
                    criteriaId: InitialIndex?.id || "",
                    dimensionId: InitialIndex?.dimensionMongoId || "",
                    subDimensionId: InitialIndex?.subDimensionMongoId || "",
                    companyId: CampaignData?.companyResponse?.id || "",
                    comment: comment,
                    optionAnswerList: [selectedOption],
                });
            }

            return { ...prev, criteriaQuestionList: updatedList };
        });
    };
    // console.log("questionList-------------------", questionList);


    //  Fetch saved answer for that criteriaId
    const getListOfSavedQution = async (criteriaId, optionResponseList = []) => {
        setOptionListloader(true);

        try {
            const response = await getOptionsByCriteriaIdwithAdminToken(criteriaId, CampaignData?.assessorCampaignResponse?.companyAssessorId, CampaignData?.assessorCampaignResponse?.campaignId);
            //  Run only if success
            if (response?.data?.responseCode === 200) {
                const questionList = response?.data?.responseBody?.criteriaQuestionList || [];
                setQuestionID(questionList[0]?.id);
                const currentSaved = questionList.find((item) => item.criteriaId === criteriaId);
                console.log("currentSaved---------------", currentSaved);

                if (currentSaved && optionResponseList?.length) {
                    const imp = currentSaved.optionAnswerList.find(
                        (x) => x.optionType?.toLowerCase() === "importance"
                    );
                    const cur = currentSaved.optionAnswerList.find(
                        (x) => x.optionType?.toLowerCase() === "current"
                    );
                    const tar = currentSaved.optionAnswerList.find(
                        (x) => x.optionType?.toLowerCase() === "future"
                    );

                    const findIndex = (val) => {
                        if (!val) return null;
                        const index = optionResponseList.findIndex(
                            (o) => o?.value?.trim()?.toLowerCase() === val?.trim()?.toLowerCase()
                        );

                        return index !== -1 ? index : null;
                    };

                    //  Set saved indexes if found
                    setImportanceIndex(imp ? findIndex(imp.optionValue) : null);
                    setCurrentIndex(cur ? findIndex(cur.optionValue) : null);
                    setTargetIndex(tar ? findIndex(tar.optionValue) : null);
                } else {
                    //  No saved data or option list empty
                    setImportanceIndex(null);
                    setCurrentIndex(null);
                    setTargetIndex(null);
                }
            }
            else {
                //  If API failed (non-200), clear selections
                setImportanceIndex(null);
                setCurrentIndex(null);
                setTargetIndex(null);
            }
        } catch (err) {
            console.error(" Error loading saved question:", err);
            toastEmitter("error", API_RESPONSE?.MESSAGE_503);
            setImportanceIndex(null);
            setCurrentIndex(null);
            setTargetIndex(null);
        } finally {
            setOptionListloader(false);
        }
    };

    //  Refetch saved answers when current question changes
    useEffect(() => {
        if (InitialIndex?.id) {
            getListOfSavedQution(InitialIndex?.id, InitialIndex?.optionResponseList);
        }
    }, [InitialIndex?.id, InitialIndex?.optionResponseList]);

    useEffect(() => {
        // When question changes, clear previous selections
        setImportanceIndex(null);
        setCurrentIndex(null);
        setTargetIndex(null);
    }, [InitialIndex?.id]);

    const validateData = () => {
        let isValid = true;
        addPayload?.criteriaQuestionList?.forEach((item) => {
            if (item?.optionAnswerList.length > 0 && item?.optionAnswerList.length < 3) {
                setValidateMessgae("Please check all three tabs, fill in all the answers, and if a tab is already selected, please reselect it.");
                isValid = false;
            } else {
                setValidateMessgae("");
            }
        });
        return isValid;
    };


    const handleNextQuestion = async (name) => {
        if (validateData()) {
            const currentCriteria = addPayload?.criteriaQuestionList?.[currentQuestionIndex];

            // Check if current question has any selected answers
            const hasAnswer = currentCriteria?.optionAnswerList?.length > 0;

            let isSaved = true; // default true so Next works if nothing to save

            if (hasAnswer) {
                // try saving only if answered
                isSaved = await handleaddAnswer(name);
            }

            if (isSaved) {
                // move next only if saved OR no answer present
                setImportanceIndex(null);
                setCurrentIndex(null);
                setTargetIndex(null);
                setCurrentQuestionIndex((prev) => prev + 1);
            }
        }

    };


    const handleaddAnswer = async (btnname, setFinalAssesmentModal) => {
        setSubmittloader(true);

        const filteredCriteriaList = addPayload?.criteriaQuestionList?.filter(
            (criteria) => criteria?.optionAnswerList && criteria?.optionAnswerList?.length > 0
        );

        const updatedPayload = {
            ...addPayload,
            isAssessment: btnname === "Submit" ? 2 : 1,
            criteriaQuestionList: filteredCriteriaList,
        };

        if (updatedPayload?.criteriaQuestionList?.length === 0) {
            setSubmittloader(false);
            return true; //nothing to save, still allow next
        }

        try {
            const response = await addAssestmentByUserWithAdminToken(updatedPayload);
            if (response?.data?.responseCode === 200) {
                if (btnname === "Submit") {
                    toastEmitter("success", response?.data?.message);
                    setSubmitBtnDisable(true);
                    setBackBtnDisable(true);
                    setFinalAssesmentModal?.(true);
                    setTimeout(() => setFinalAssesmentModal?.(false), 5000);
                }
                setAddpayload(response?.data?.responseBody?.[0]);
                setSubmittloader(false);
                return true; //saved successfully
            } else {
                toastEmitter("error", response?.data?.message || "Save failed");
                setSubmittloader(false);
                return false; //  failed
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE?.MESSAGE_503);
            setSubmittloader(false);
            return false; //  failed
        }
    };

    const handleBackQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1)
        }
        // Update the addPayload to clear optionAnswerList for the current question
        setAddpayload((prevPayload) => {
            if (!prevPayload?.criteriaQuestionList) return prevPayload; // Guard clause
            const updatedCriteriaList = prevPayload?.criteriaQuestionList?.map((criteria) => {
                // Check if the current question matches the criteriaId
                if (criteria?.criteriaId === InitialIndex?.id) {
                    return {
                        ...criteria,
                        optionAnswerList: [] // Set optionAnswerList to an empty array
                    };
                }
                return criteria; // Return other criteria unchanged 
            });
            return {
                ...prevPayload,
                criteriaQuestionList: updatedCriteriaList
            };
        });
        setValidateMessgae("");
    }

    const handleClearResponce = async () => {
        if (questionID) {
            try {
                const response = await clearResponeAssesmentAdmin(questionID);
                if (response?.data?.responseCode === 200) {
                    setQuestionID();
                    setImportanceIndex(null);
                    setCurrentIndex(null);
                    setTargetIndex(null);

                    // Update the addPayload to clear optionAnswerList for the current question
                    setAddpayload((prevPayload) => {
                        if (!prevPayload?.criteriaQuestionList) return prevPayload; // Guard clause

                        const updatedCriteriaList = prevPayload?.criteriaQuestionList?.map((criteria) => {
                            // Check if the current question matches the criteriaId
                            if (criteria?.criteriaId === InitialIndex?.id) {
                                return {
                                    ...criteria,
                                    optionAnswerList: [] // Set optionAnswerList to an empty array
                                };
                            }
                            return criteria; // Return other criteria unchanged
                        });

                        return {
                            ...prevPayload,
                            criteriaQuestionList: updatedCriteriaList
                        };
                    });
                    setValidateMessgae("");
                }
            } catch (err) {
            }

        } else {
            setImportanceIndex(null);
            setCurrentIndex(null);
            setTargetIndex(null);
            // Update the addPayload to clear optionAnswerList for the current question
            setAddpayload((prevPayload) => {
                if (!prevPayload?.criteriaQuestionList) return prevPayload; // Guard clause

                const updatedCriteriaList = prevPayload?.criteriaQuestionList?.map((criteria) => {
                    // Check if the current question matches the criteriaId
                    if (criteria?.criteriaId === InitialIndex?.id) {
                        return {
                            ...criteria,
                            optionAnswerList: [] // Set optionAnswerList to an empty array
                        };
                    }
                    return criteria; // Return other criteria unchanged
                });
                return {
                    ...prevPayload,
                    criteriaQuestionList: updatedCriteriaList
                };
            });
            setValidateMessgae("");
        }
    }

    const handleCriteriaSelect = (criteriaId) => {
        const index = questionList.findIndex((q) => q.id === criteriaId);
        if (index !== -1) setCurrentQuestionIndex(index);
    }


    // Render slider
    const renderSlider = (levels, selectedIndex, setIndex, bubbleText, radioName) => {
        // Determine what to show in bubble text
        const displayName = bubbleText === "future" ? "Target" : bubbleText;

        return (
            <div className="d-flex justify-content-end bullbe-container position-relative mt-3">
                <div
                    className="bubble position-absolute transition-all"
                    style={{
                        left: selectedIndex === null ? "0%" : positionMap[selectedIndex],
                        transition: "left 0.4s ease",
                    }}
                >
                    <p>{displayName}</p>
                </div>

                <div className="sliderNew position-relative">
                    {/* Colored fill till selected index */}
                    <div
                        className="slider-fill"
                        style={{
                            width:
                                selectedIndex === null
                                    ? "0%"
                                    : `${((selectedIndex + 1) / levels?.optionResponseList?.length) * 100}%`,
                        }}
                    ></div>

                    {levels?.optionResponseList?.map((level, i) => (
                        <div
                            key={level.id}
                            className="slider-item d-flex flex-column align-items-center position-relative"
                        >
                            <input
                                type="radio"
                                name={radioName}
                                className="radio-dot"
                                value={level?.value}
                                checked={selectedIndex === i}
                                onChange={() =>
                                    handleRadioChange(setIndex, { ...level, index: i }, bubbleText)
                                }
                            />

                            {bubbleText === "Importance" ? (
                                <label className="radio-label mt-3 text-center">
                                    {level?.value === "Initiating" && "Not at all Important"}
                                    {level?.value === "Emerging" && "Low Importance"}
                                    {level?.value === "Performing" && "Moderately Important"}
                                    {level?.value === "Advancing" && "Highly Important"}
                                    {level?.value === "Leading" && "Critically Important"}
                                </label>
                            ) : (
                                <label className="radio-label mt-3 text-center">
                                    {level.value}
                                </label>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    };


    return (
        <>
            {
                !showPreview ? <>
                    <OnSiteAssessmentTopBar />
                    {
                        <div className={`${questionList.length ? "main_assesment_section" : ""}`}>
                            <div className="row m-0">
                                <div className="col-12">
                                    <div className="progress-container">
                                        <div className="row">
                                            <div className="col-12 ps-4">
                                                <label className="progress-label ">Overall Progress</label>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-12 ps-4">
                                                <span
                                                    className="progress-tooltip"
                                                    style={{
                                                        left: `${progress ? `${progress}%` : '2%'}`,
                                                        transform: 'translateX(-50%)',
                                                    }}
                                                >
                                                    {Math?.round(progress || 0)}%
                                                </span>
                                                <div className="progress-bar-wrapper">
                                                    <div className="progress-bar">
                                                        <div className="progress-fill" style={{ width: `${progress}%` }}>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="row m-0">
                                <div className={sidebarCollapsed ? "col-md-1 p-0" : "col-md-3 p-0"}>
                                    <AdminTesteftbar CampaignData={CampaignData}
                                        // collapsed={sidebarCollapsed}
                                        // toggleSidebar={toggleSidebar}
                                        onCriteriaSelect={handleCriteriaSelect}
                                        selectedCriteriaId={InitialIndex?.id}
                                        parsedEmployeeData={parsedEmployeeData}
                                        pageName="qutionLeftbar"
                                    //   handleClearResponce={handleClearResponce} 
                                    //   setCurrentIndex={setCurrentIndex} 
                                    //   attemptQutionTeg={attemptQutionTeg} 
                                    //   clearQutionTeg={clearQutionTeg} 
                                    />
                                </div>
                                {(!quesListLoader && !optionListLoader && !ansListLoader && !submitLoader) ? <> <div className={sidebarCollapsed ? "col-md-11 p-0" : "col-md-9 p-0 "}>
                                    <div className="user_profile_intro_right bg-color p-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="question-sec-withId d-flex align-items-center justify-content-start">
                                                    <p>

                                                        <span className="criteriaQutionNo"> {InitialIndex?.criteriaId}{" "} :{" "}</span>
                                                        {InitialIndex?.criteriaDescription}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="question-sec-withId mt-3">
                                            {renderSlider(
                                                InitialIndex,
                                                importanceIndex,
                                                setImportanceIndex,
                                                "Importance",
                                                "importance"
                                            )}
                                        </div>


                                        {importanceIndex !== null && (
                                            <>
                                                <div className="d-flex justify-content-between flex-wrap mt-3">
                                                    {InitialIndex?.optionResponseList?.map((item, i) => {
                                                        const isActive = currentIndex === i || targetIndex === i;
                                                        return (
                                                            <div key={i} className={`desc-card ${isActive ? "active" : ""}`}>
                                                                <p>{cleanInvalidChars(decodeHtmlEntities(item?.description))}</p>
                                                            </div>
                                                        );
                                                    })}
                                                </div>

                                                {renderSlider(InitialIndex, currentIndex, setCurrentIndex, "Current", "current")}
                                                {renderSlider(InitialIndex, targetIndex, setTargetIndex, "future", "target")}



                                                <div className="row m-0">
                                                    <div className="col-12">
                                                        <textarea
                                                            className="comment-box"
                                                            value={comment}
                                                            onChange={(e) => {
                                                                const newComment = e.target.value;
                                                                setComment(newComment);

                                                                //  also update payload in real-time
                                                                setAddpayload((prev) => {
                                                                    let updatedList = [...(prev?.criteriaQuestionList || [])];
                                                                    const existingIndex = updatedList.findIndex(
                                                                        (q) => q.criteriaId === InitialIndex?.id
                                                                    );

                                                                    if (existingIndex !== -1) {
                                                                        updatedList[existingIndex] = {
                                                                            ...updatedList[existingIndex],
                                                                            comment: newComment,
                                                                        };
                                                                    } else {
                                                                        updatedList.push({
                                                                            id: "",
                                                                            criteriaId: InitialIndex?.id || "",
                                                                            dimensionId: InitialIndex?.dimensionResponse?.id || "",
                                                                            subDimensionId: InitialIndex?.subDimensionResponse?.id || "",
                                                                            companyId: parsedEmployeeData?.companyId || "",
                                                                            comment: newComment,
                                                                            optionAnswerList: [],
                                                                        });
                                                                    }

                                                                    return { ...prev, criteriaQuestionList: updatedList };
                                                                });
                                                            }}
                                                            placeholder="Additional Comments"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mt-3">
                                                    <div className="col-4 pb-5">
                                                        {currentQuestionIndex === 0 ? "" : <button
                                                            className='quizesave-prevbtn px-3'
                                                            onClick={handleBackQuestion}
                                                            disabled={currentQuestionIndex === 0} // Disable on first question
                                                        >
                                                            Back Question
                                                        </button>}
                                                    </div>
                                                    <div className="col-4 d-flex justify-content-center">
                                                        <button className="quiznextbtn px-3" onClick={handleClearResponce}>Clear Response</button>
                                                    </div>
                                                    <div className="col-4 d-flex justify-content-end">
                                                        <button
                                                            type="button"
                                                            disabled={isNextDisabled}
                                                            className="quiznextbtn px-3"
                                                            onClick={async () => {
                                                                if (currentQuestionIndex < questionList?.length - 1) {
                                                                    handleNextQuestion("Save and Next");
                                                                } else {
                                                                    // Wait for API call to finish
                                                                    const isSaved = await handleaddAnswer("Save and Next");

                                                                    //  Only show preview if API success (responseCode === 200)
                                                                    if (isSaved) {
                                                                        setShowPreview(true);
                                                                    } else {
                                                                        toastEmitter("error", "Unable to save. Please try again before previewing.");
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {currentQuestionIndex < questionList?.length - 1
                                                                ? "Save and Next"
                                                                : "Save and Preview"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {importanceIndex === null && (
                                            <div className="row mt-3">
                                                <div className="col-6">
                                                    {currentQuestionIndex === 0 ? "" : (
                                                        <button
                                                            className="quizesave-prevbtn px-3"
                                                            onClick={handleBackQuestion}
                                                            disabled={currentQuestionIndex === 0}
                                                        >
                                                            Back Question
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    <button
                                                        className="quiznextbtn px-3"
                                                        onClick={async () => {
                                                            if (currentQuestionIndex < questionList?.length - 1) {
                                                                handleNextQuestion("Save and Next");
                                                            } else {
                                                                // Wait for API call to finish
                                                                const isSaved = await handleaddAnswer("Save and Next");

                                                                //  Only show preview if API success (responseCode === 200)
                                                                if (isSaved) {
                                                                    setShowPreview(true);
                                                                } else {
                                                                    toastEmitter("error", "Unable to save. Please try again before previewing.");
                                                                }
                                                            }
                                                        }}

                                                    >
                                                        {currentQuestionIndex < questionList?.length - 1
                                                            ? "Skip"
                                                            : "Skip and Preview"}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                        {validationMessage && (
                                            <div className="text-danger mt-2">{validationMessage}</div>
                                        )}
                                        {validateMessgae ? <>
                                            <div className='row mt-4 mb-4'>
                                                <div className='col-12'>
                                                    <p className='text-danger'>{validateMessgae}</p>
                                                </div>
                                            </div>
                                        </> : ""}
                                    </div>
                                </div></> : <>
                                    <div className='loader-user'> <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    </div>
                                </>}
                                {(questionList.length === 0 && !quesListLoader) && <div><h5 className='no-data-found'>There are no records to display for this user!</h5></div>}
                            </div>
                        </div>

                    }

                </> : <PreviewAllAdminAns CampaignData={CampaignData} parsedEmployeeData={parsedEmployeeData} setShowPreview={setShowPreview} handleaddAnswer={handleaddAnswer} setFinalAssesmentModal={setFinalAssesmentModal} finalAssesmentModal={finalAssesmentModal} setBackBtnDisable={setBackBtnDisable} setSubmitBtnDisable={setSubmitBtnDisable} submitBtnDisable={submitBtnDisable} backBtnDisable={backBtnDisable} />
            }
        </>
    )
}

export default AddOnSiteScore
